export default __webpack_public_path__ + "static/media/sc50.dd02e04e.mp4";